<template>
  <div class="fullbody">
    <div v-if="!recuperacaoEnviada">
      <div class="container">
        <h1>Recuperação de senha</h1>
      </div>
      <hr />
      <form @submit.prevent="submitForm">
        <div class="login">
          <h2>Por favor informe o email</h2>
          <div class="mb-3">
            <label for="email">Email:</label>
            <input type="text" id="email" v-model.trim="email.val" style="border: 1px solid black;"/>
            <div class="form-text">
              A senha será enviada para o email cadastrado.
            </div>
            <br />
            <div class="button-control">
              <button class="active" @click="validateForm">Enviar</button>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div v-else class="container">
      <div v-if="isLoading"><base-spinner></base-spinner><br /></div>
      <div v-else class="recuperaSenha">
        <h3>{{ carregamentoSenha }}</h3>
        <router-link :to="loginLink" v-slot="{ href, route, navigate }">
          <button class="active" :href="href" @click="navigate()">
            Voltar para o login{{ route.MinhaConta }}
          </button></router-link
        >
      </div>
    </div>
  </div>
  <AppFooter id="footer" />

</template>

<script>
import AppFooter from "@/components/AppFooter.vue";
import { mapState } from "vuex";

export default {
  components: {
    AppFooter
  },
  data() {
    return {
      email: {
        val: "",
        isValid: true,
      },
      recuperacaoEnviada: false,
      isLoading: false,
    };
  },
  computed: {
    ...mapState("empresa", ["empresarodape"]),
    ...mapState("login", ["carregamentoSenha"]),
    loja() {
      return this.$store.getters["loja/lojaSelecionada"];
    },
    tipo() {
      return this.$store.getters["loja/tipoSelecionado"];
    },
    loginLink() {
      return "/" + this.tipo + "/" + this.loja + "/produtos/minhaconta";
    },
  },
  methods: {
    async carregarRodape() {
      await this.$store.dispatch("empresa/carregarRodape");
      document.title = this.empresarodape.nome;
    },
    async carregarCategorias() {
      await this.$store.dispatch("produtos/carregarCategorias");
    },
    validateForm() {
      this.formIsValid = true;
      if (this.email.val == "" || !this.email.val.includes("@")) {
        this.email.isValid = false;
        this.formIsValid = false;
        this.top();
      }
    },
    clearValidity(input) {
      this[input].isValid = true;
    },
    async submitForm() {
      if (this.formIsValid == true) {
        this.recuperacaoEnviada = true;
        this.isLoading = true;
        await this.$store.dispatch("login/recuperarSenha", {
          email: this.email.val,
        });
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped>
@import "@/styles/variables.css";

.fullbody {
  min-height: 100vh;
}

h1 {
  color: var(--primary-color);
  margin: 25px 40px 25px 10px;
}

.form-control,
.button-control {
  display: inline;
  padding: 0px;
  margin: auto;
  max-width: 50rem;
  border-radius: 10px;
  border: 0px;
}

.active {
  font: inherit;
  cursor: pointer;
  color: white;
  background-color: var(--primary-color);
  border: none;
  margin: 0px 20px 0px 0px;
  padding: 0.5rem 1.5rem;
  border-radius: 30px;
}

button {
  font: inherit;
  cursor: pointer;
  color: black;
  background-color: transparent;
  border: none;
  margin: 0px 20px 0px 0px;
  padding: 0.5rem 1.5rem;
  border-radius: 30px;
}

button:hover {
  font: inherit;
  cursor: pointer;
  color: white;
  background-color: var(--primary-color);
  border: none;
  margin: 0px 20px 0px 0px;
  padding: 0.5rem 1.5rem;
  border-radius: 30px;
}

.login {
  border: 1px solid black;
  padding: 20px;
  border-radius: 10px;
}

h2 {
  text-align: center;
  background: var(--primary-color);
  color: white;
  padding: 10px;
  border: 1px solid black;
  margin: -21px -21px 0px -21px;
  border-radius: 10px 10px 0px 0px;
}

form {
  text-align: left;
  padding: 1rem;
  margin: auto;
  width: 35rem;
}

label {
  font-weight: bold;
  display: block;
  margin: 1rem 0;
}

.invalid label {
  color: red;
}

.invalid input,
.invalid select,
.invalid textarea {
  border: 1px solid red;
}

a {
  text-decoration: none;
  color: black;
}

a:hover {
  color: var(--primary-color);
}

.recuperaSenha {
  margin: auto;
  text-align: center;
  padding: 20px;
}
</style>
